import clsx from 'clsx';
import LayoutContext from 'components/UI/Layout/LayoutContext';
import React from 'react';
import PropTypes from 'prop-types';
import { get, isNumber } from 'lodash';

function Row({
    children, className, reversed, spacing, vSpacing,
})
{
    return (
        <LayoutContext.Consumer>
            {(containerProps) =>
            {
                const vSpacingValue = isNumber(vSpacing) ? vSpacing : get(containerProps, 'vSpacing');

                let finalVspacing = vSpacingValue;
                if (vSpacingValue === true) finalVspacing = isNumber(spacing) ? spacing : get(containerProps, 'spacing');

                const classes = clsx({
                    'tw-flex': true,
                    'tw-flex-row': !reversed,
                    'tw-flex-row-reverse': reversed,
                    [className]: true,
                    [`tw-my-${finalVspacing}`]: !!finalVspacing,
                });

                return (
                    <div className={classes}>
                        {children}
                    </div>
                );
            }}
        </LayoutContext.Consumer>

    );
}

Row.displayName = 'Row';

Row.defaultProps = {
    className: '',
    reversed: false,
};

Row.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    reversed: PropTypes.bool,
    spacing: PropTypes.number,
    vSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default Row;
